module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-home-6ccca42fda21bdca2b2db8c64ed7dd91.svg";